export const faLocale = {
    relativeTime: {
        future: "در %s",
        past: "%s پیش",
        s: "چند ثانیه اخیر",
        ss: "%d ثانیه",
        m: "دقیقه ای پیش",
        mm: "%d دقیقه",
        h: "ساعتی پیش",
        hh: "%d ساعت",
        d: "روز قبل",
        dd: "%d روز",
        w: "هفته اخیر",
        ww: "%d هفته",
        M: "یک ماه",
        MM: "%d ماه",
        y: "یک سال",
        yy: "%d سال",
    },
};
